/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   7/28/21
 */

import {colors, Theme} from "@mui/material";

export const EMPLOYEE_COL_WIDTH = 250;

export const fixedSx = (theme: Theme) => ({
	position: "sticky" as "sticky",
	backgroundColor: theme.palette.background.paper,
	borderRight: "1px solid " + theme.palette.divider,
	left: 0,
	zIndex: 200,
	minWidth: EMPLOYEE_COL_WIDTH,
	maxWidth: EMPLOYEE_COL_WIDTH,
});

export const borderedSx = (theme: Theme) => ({
	borderTop: "1px solid " + theme.palette.divider,
	borderLeft: "1px solid " + theme.palette.divider,
});

export const lastOfTypeX = (theme: Theme) => ({
	"&:last-of-type": {
		borderRight: "1px solid " + theme.palette.divider
	},
});

export const lastOfTypeY = (theme: Theme) => ({
	"&:last-of-type": {
		borderBottom: "1px solid " + theme.palette.divider
	},
});

export const cellSx = {
	textAlign: "center" as "center"
};

export const footerFixedSx = {
	borderLeft: 0,
	backgroundColor: "background.default",
	borderTop: "1px solid",
	borderColor: "divider"
};

export const contentSx = {
	width: "fit-content"
}

export const weekendSx = (theme: Theme) => ({
	backgroundColor: theme.palette.grey[ theme.palette.mode === "light" ? 100 : 800],
});

export const todaySx = (theme: Theme) => ({
	backgroundColor: theme.palette.mode === "light" ? colors.yellow[50] : "#8B4500"
});